// src/config/apiConfig.js

// Determine environment characteristics
const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
const isPrivateNetworkHost = /^10\.|^192\.168\.|^172\.(1[6-9]|2\d|3[0-1])\./.test(hostname);
const isLoopbackHost = ['localhost', '127.0.0.1', '0.0.0.0'].includes(hostname);
const isLocalTld = hostname.endsWith('.local');
export const isDevelopment = (
  process.env.NODE_ENV !== 'production' || isLoopbackHost || isLocalTld || isPrivateNetworkHost
);

// Resolve API base
const ENV_API_BASE_RAW = (process.env.REACT_APP_API_URL || '').trim();
const ENV_API_BASE = ENV_API_BASE_RAW.replace(/\/+$/, '');
// Cloud Run exposes the stable service URL with the random suffix; the project-number
// domain currently responds with 404s for new endpoints like /api/artworks.
const DEFAULT_PROD_API_BASE = 'https://togeevision-backend-6mrcf4vioa-uc.a.run.app';
const PROJECT_NUMBER_API_BASE = 'https://togeevision-backend-6mrcf4vioa-uc.a.run.app';

// Production should default to the backend service origin. Relying on same-origin
// from togeevision.com can 404 for endpoints not proxied by the web host.
const SHOULD_USE_SAME_ORIGIN = isDevelopment;
export const API_BASE_URL = ENV_API_BASE || (SHOULD_USE_SAME_ORIGIN ? '' : DEFAULT_PROD_API_BASE);
export const API_BASE_CANDIDATES = Array.from(
  new Set(
    [
      ENV_API_BASE,
      // Always allow relative URLs in development and when no explicit base is provided
      (!ENV_API_BASE || isDevelopment) ? '' : null,
      DEFAULT_PROD_API_BASE,
      PROJECT_NUMBER_API_BASE,
    ].filter((value) => value !== null && value !== undefined)
  )
);

export const resolveApiBaseUrl = ({ fallbackToSameOrigin = true } = {}) => {
  if (ENV_API_BASE) return ENV_API_BASE;
  if (isDevelopment) return fallbackToSameOrigin ? '' : DEFAULT_PROD_API_BASE;
  return DEFAULT_PROD_API_BASE;
};

if (typeof window !== 'undefined' && !isDevelopment && !ENV_API_BASE && process.env.NODE_ENV === 'production') {
  // eslint-disable-next-line no-console
  console.warn(
    'REACT_APP_API_URL is not set. API calls will use the default Cloud Run backend origin. ' +
      'Set REACT_APP_API_URL to override this origin.'
  );
}

// Public GCS bucket used to serve audio files directly
export const GCS_PUBLIC_BUCKET = process.env.REACT_APP_GCS_PUBLIC_BUCKET
  || 'staging.togeevision-f3725.appspot.com';
